import { z } from "zod";

import { isEmail } from "../../../../utils/validation";
import { isTravelokaEmailDetected } from "../helper";

export const LOGIN_FORM_VALIDATION_SCHEMA = z
  .object({
    email: z.string().refine((v) => isEmail(v)),
    password: z.string(),
  })
  .refine(
    (data) => {
      return isTravelokaEmailDetected(data.email) || !!data.password;
    },
    {
      path: ["password"],
    }
  );

export type LoginFormValues = z.infer<typeof LOGIN_FORM_VALIDATION_SCHEMA>;
